import * as React from "react";

function SvgMarketo(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 56 65"
      fill="#fff"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <use xlinkHref="#marketo_svg__a" x={0.5} y={0.5} />
      <symbol id="marketo_svg__a" overflow="visible">
        <path
          d="M54.812 50.972V8.892L38.467 0v64zM17.688 5.563l13.17 3.9v40.56l-13.17 5.753zm-7.608 8.274L.048 12.22 0 48.547l10.08-2.663z"
          stroke="none"
          fill="#5c4c9f"
          fillRule="nonzero"
        />
      </symbol>
    </svg>
  );
}

export default React.forwardRef(SvgMarketo);
